import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noResultsText: {
    id: "meetingtemplatelist.noresults.text",
    defaultMessage: "No results",
    description: "Text to be shown when no results from meeting list",
  },
});
